import React, { useEffect, useRef, useState } from "react";

const DmsSystemOverviewSection = ({ overviewCards }) => {
  const sectionRef = useRef();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="hris-system-future-section py-5" ref={sectionRef}>
      <div className="container">
        <h2 className="text-center fw-bold mb-4 hris-section-title">
          System Overview
        </h2>
        <div className="row text-center mb-5">
          {overviewCards.map((card, i) => (
            <div className="col-12 col-sm-6 col-lg-3 mb-4 d-flex" key={i}>
              <div
                className={`hris-overview-card d-flex flex-column justify-content-start align-items-center w-100 ${
                  isVisible
                    ? i % 2 === 0
                      ? "hris-slide-top"
                      : "hris-slide-bottom"
                    : ""
                }`}
              >
                <img
                  src={card.image}
                  alt={card.title}
                  width="100"
                  height="100"
                  className="rounded-circle mb-3"
                />
                <h5 className="fw-bold hris-card-title text-center">
                  {card.title}
                </h5>
                <p className="text-muted hris-card-description text-center">
                  {card.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DmsSystemOverviewSection;
